
import { 
  CreateProductCategoryDiscount, 
  GetByCustomer, 
  ProductCategoryDiscount, 
  UpdateProductCategoryDiscount 
} from "../../Models/ProductCategoryDiscount";
import api from "../axios";

export const productCategoryDiscountService = {
  getByCustomer: async (data: GetByCustomer): Promise<ProductCategoryDiscount[]> => {
    const response = await api.post('/product-category-discount/by-customer/', data);
    return response.data;
  },
  
  create: async (data: CreateProductCategoryDiscount): Promise<string | null> => {
    const response = await api.post('/product-category-discount', data);
    return response.data;
  },

  update: async (data: UpdateProductCategoryDiscount): Promise<boolean> => {
    const response = await api.put('/product-category-discount', data);
    return response.data;
  },

  delete: async (id: string): Promise<boolean> => {
    const response = await api.delete(`/product-category-discount/${id}`);
    return response.data;
  }
};
